module.exports = __webpack_public_path__ + "img/Feature.333b8441.png";